import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allVatReports } from 'app/mocks/data/reports/vat'

import { api } from 'app/utils/constants'

import { StatusReport } from 'app/types/reports'
import type { InitialVatReport } from 'app/types/reports/vat'

export const getVatReport = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.reports.vat.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const vatReportFound = allVatReports.find(
            (vat) => vat.id.toString() === id,
        )

        // Not found
        if (!vatReportFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        // Not generated
        if (vatReportFound.status === StatusReport.enum.IN_PROGRESS) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.CONFLICT,
            })
        }

        return HttpResponse.json<InitialVatReport>(vatReportFound)
    },
)
